import { render, staticRenderFns } from "./company-contractor-stakes-table.vue?vue&type=template&id=4f185d6c&scoped=true"
import script from "./company-contractor-stakes-table.vue?vue&type=script&lang=js"
export * from "./company-contractor-stakes-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f185d6c",
  null
  
)

export default component.exports